import React from 'react';
import { BodyTextSmall, HeadlineTextSmall } from 'Packages/FacetDesign/Components';
import { FDContentContainer, FDStack } from '@facet-wealth/design';
import SmartAutoCustomizationGroupsPicker from './SmartAutoCustomizationGroupsPicker';
import { useSmartAllocationCustomizationContext } from '../Context';
import ResetButtonPicker from './ResetButtonPicker';

const SmartAutoCustomization = () => {
  const {
    sacGroupsCollection,
    smartAllocCustResource,
  } = useSmartAllocationCustomizationContext();

  if (!sacGroupsCollection || !smartAllocCustResource) {
    return null;
  }

  return (
    <FDContentContainer maxWidth={'md'}>
      <FDStack padding={2} direction={'column'} spacing={2} alignItems={'stretch'}>
        <FDStack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
          <HeadlineTextSmall
            color={'textSecondary'}
            value={smartAllocCustResource.attr('title')}
          />
          <ResetButtonPicker />
        </FDStack>
        <BodyTextSmall value={smartAllocCustResource.attr('description')} />
        <SmartAutoCustomizationGroupsPicker sacGroupsCollection={sacGroupsCollection} />
      </FDStack>
    </FDContentContainer>
  );
};

export default SmartAutoCustomization;
